export class PopupData {
  static cropperStaticWidth = 1280;
  static cropperStaticHeight = 720;
  static aspectRatio = this.cropperStaticWidth / this.cropperStaticHeight;
}
